import {LayoutVo} from '../../common/shared/api/karina/vo/LayoutVo.interface';
import {
  DynamicLayoutReference,
  Maybe,
  MetaInfoType,
  SectionType,
  User,
} from '../generated/types';
import {createReferenceRequestVo} from './DataKey';
import {createLayoutReferenceViewDataList} from './LayoutReferenceViewDataList';

export function createDynamicLayout(
  userInfo: Maybe<User>,
  {
    dataKey,
    layout,
    sectionType,
    metaInfoType,
  }: {
    dataKey: string;
    layout: LayoutVo;
    sectionType: SectionType;
    metaInfoType?: Maybe<MetaInfoType>;
  }
): DynamicLayoutReference | null {
  const layoutReference = createLayoutReferenceViewDataList(userInfo, {
    dataKeyList: [dataKey],
    layout,
    sectionType,
    metaInfoType,
  });
  if (layoutReference.length === 0 || !layoutReference[0].items?.length) {
    return null;
  }

  const dynamicLayout =
    layout.reference?.dynamic_layout[
      createReferenceRequestVo(dataKey).reference_key
    ];

  return {
    layoutReference,
    dynamicLayout: {
      title: dynamicLayout?.title,
      subTitle: dynamicLayout?.sub_title,
      description: dynamicLayout?.description,
      scheme: dynamicLayout?.scheme,
    },
  };
}
